<div>
  <form [formGroup]="form" (ngSubmit)="modelRecived ? update(form.getRawValue()) : create(form.value)" class="mt-3" appPermissionControl="P116F0001">
    <div class="form-row mt-3">
      <div class="form-field flex-grow-1">
        <select class="form-control" formControlName="parametro" [attr.disabled]="modelRecived ? '' : null" appPermissionControl="P116K0001">
          <option value appPermissionControl="P116K0002">Seleccione parámetro</option>
          <option *ngFor="let param of listParametro" [value]="param.value" appPermissionControl="P116K0003">
            {{ param.label }}
          </option>
        </select>
        <label>Parámetro *</label>
        <small class="text-danger" *ngIf="formValue('parametro')?.errors?.required && formValue('parametro')?.touched"> El parámetro es requerido </small>
      </div>

      <div class="form-field flex-grow-1">
        <select class="form-control" formControlName="producto" [attr.disabled]="modelRecived ? '' : null" appPermissionControl="P116K0004">
          <option value appPermissionControl="P116K0005">Seleccione promoción</option>
          <option *ngFor="let prod of listProducto" [value]="prod.value" appPermissionControl="P116K0006">
            {{ prod.label }}
          </option>
        </select>
        <label>Promoción</label>
      </div>
    </div>

    <div class="form-row mt-3">
      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="valor" appPermissionControl="P116K0007" />
        <label>Valor *</label>
        <small class="text-danger" *ngIf="formValue('valor')?.errors?.required && formValue('valor')?.touched"> El valor es requerido </small>
      </div>

      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="descripcion" appPermissionControl="P116K0008" />
        <label>Descripción *</label>
        <small class="text-danger" *ngIf="formValue('descripcion')?.errors?.required && formValue('descripcion')?.touched"> La descripción es requerida </small>
      </div>
    </div>

    <div class="button-section mt-3">
      <button mat-flat-button [disabled]="!form.valid || loading" class="btn-success" appPermissionControl="P116B0001">
        <mat-icon>save</mat-icon>
        {{ loading ? (modelRecived ? 'Actualizando...' : 'Guardando...') : modelRecived ? 'Actualizar' : 'Guardar' }}
      </button>
    </div>
  </form>
</div>

<style>
  .form-control.ng-invalid.ng-touched {
    border-color: #dc3545;
  }

  .form-control.ng-invalid.ng-touched + label {
    color: #dc3545;
  }

  .text-danger {
    font-size: 0.75rem;
    margin-top: 0.25rem;
  }
  [disabled] {
    cursor: not-allowed;
  }
</style>
